import React, { useEffect, useState } from 'react';
import api from '../api';
import * as XLSX from 'xlsx';
import '../styles/relatorioCursos.scss';

const RelatorioCursos = () => {
    const [relatorioCursos, setRelatorioCursos] = useState([]);
    const [filteredCursos, setFilteredCursos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const cursosPorPagina = 10;

    useEffect(() => {
        const fetchRelatorioCursos = async () => {
            try {
                const response = await api.get('/relatorio/cursos');
                const cursos = Object.entries(response.data.cursoPorPolo).flatMap(([curso, polos]) =>
                    polos.map(polo => ({
                        'CURSO OFERTADO': curso,
                        'QUANTIDADE': polos.length, // ou outro dado que você deseja exibir
                        'POLO': polo.nome // Se precisar do nome do polo
                    }))
                );
                setRelatorioCursos(cursos);
                setFilteredCursos(cursos);
            } catch (error) {
                console.error('Erro ao buscar relatório de cursos:', error);
            }
        };

        fetchRelatorioCursos();
    }, []);

    useEffect(() => {
        const results = relatorioCursos.filter(curso =>
            curso['CURSO OFERTADO'].toLowerCase().includes(searchTerm.toLowerCase()) ||
            curso.POLO.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredCursos(results);
        setCurrentPage(1);
    }, [searchTerm, relatorioCursos]);

    const downloadExcel = () => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(filteredCursos);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Relatório de Cursos');

        const now = new Date();
        const formattedDate = now.toLocaleString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).replace(/\//g, '-').replace(',', '');

        const fileName = `RelatorioCursos—${formattedDate}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    };

    const indexOfLastRelatorio = currentPage * cursosPorPagina;
    const indexOfFirstRelatorio = indexOfLastRelatorio - cursosPorPagina;
    const currentRelatorio = filteredCursos.slice(indexOfFirstRelatorio, indexOfLastRelatorio);
    const totalPages = Math.ceil(filteredCursos.length / cursosPorPagina);

    const getPaginationButtons = () => {
        const buttons = [];
        const maxButtonsToShow = 5;
        buttons.push(1);

        if (currentPage > 3) {
            buttons.push("...");
        }

        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
            buttons.push(i);
        }

        if (currentPage < totalPages - 2) {
            buttons.push("...");
        }

        if (totalPages > 1) {
            buttons.push(totalPages);
        }

        return buttons;
    };

    return (
        <div>
            <h1>Relatório de Cursos</h1>
            <input
                type="text"
                placeholder="Filtrar por nome do curso ou Polo"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button className='btn-download-excel' onClick={downloadExcel}>Download Excel</button>
            <table>
                <thead>
                    <tr>
                        <th>Curso Ofertado</th>
                        <th>Quantidade</th>
                        <th>Polo</th>
                    </tr>
                </thead>
                <tbody>
                    {currentRelatorio.map((curso, index) => (
                        <tr key={index}>
                            <td>{curso['CURSO OFERTADO']}</td>
                            <td>{curso['QUANTIDADE']}</td>
                            <td>{curso['POLO']}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                {getPaginationButtons().map((page, index) => (
                    <button key={index} onClick={() => {
                        if (page !== "...") {
                            setCurrentPage(page);
                        }
                    }} disabled={page === "..."}>{page}</button>
                ))}
            </div>
        </div>
    );
};

export default RelatorioCursos;
